var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion"},_vm._l((_vm.numberOfDropdowns),function(index){return _c('div',{key:index},[_vm._t(("dropdown" + (index - 1)),null,{"closeOpened":_vm.closeOpened})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }